/**
 * Joins class names, dropping falsy entries. The one helper the design system needs; no
 * dependency for it.
 *
 * @param {(string | false | null | undefined)[]} parts -- Class fragments.
 * @returns The joined class string.
 */
export const cx = (...parts: (string | false | null | undefined)[]): string =>
  parts.filter((part): part is string => typeof part === 'string' && part.length > 0).join(' ');
